import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 60%;

  @media (max-width: 672px) {
    width: 95%;
  }
`;
